/**
 * ログイン導線 UI（案A・フェーズ3）。
 *
 * - 未ログイン: 「ログイン」ボタン → モーダル（「Google で続ける」）→ Hosted UI 遷移
 * - ログイン中: 何も出さない（表示・ログアウトは UserMenu が担当）
 *
 * マップは公開のまま。ログインは任意アクション（閲覧者はログイン不要）。
 */
import { useState } from 'react';
import type { UseAuthResult } from './useAuth';
import type { Lang } from '../i18n/lang';
import { messages } from '../i18n/messages';
import './loginControl.css';

export interface LoginControlProps {
  /** App で一度だけ呼んだ useAuth の結果を渡す（認証処理の重複実行を避ける）。 */
  readonly auth: UseAuthResult;
  readonly lang: Lang;
}

export function LoginControl({ auth, lang }: LoginControlProps) {
  const { enabled, user, loading, login } = auth;
  const [modalOpen, setModalOpen] = useState(false);
  const m = messages(lang);

  // 認証未設定（env 無し）または初期化中は何も出さない
  if (!enabled || loading) {
    return null;
  }

  // ログイン中は UserMenu が表示・操作を担うので、ここでは何も出さない
  if (user) {
    return null;
  }

  return (
    <>
      <div className="login-control">
        <button
          type="button"
          className="login-control__btn login-control__btn--primary"
          onClick={() => setModalOpen(true)}
        >
          {m.login.trigger}
        </button>
      </div>

      {modalOpen && (
        <div
          className="login-modal__overlay"
          onClick={() => setModalOpen(false)}
        >
          <div
            className="login-modal"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-label={m.login.title}
          >
            <h2 className="login-modal__title">{m.login.title}</h2>
            <p className="login-modal__desc">{m.login.desc}</p>
            <button
              type="button"
              className="login-modal__google"
              onClick={() => login()}
            >
              {m.login.google}
            </button>
            <button
              type="button"
              className="login-modal__cancel"
              onClick={() => setModalOpen(false)}
            >
              {m.common.cancel}
            </button>
          </div>
        </div>
      )}
    </>
  );
}
